<template>
  <a-card class="Learning">
    <div :class="advanced ? 'search' : null">
      <a-form layout="horizontal" class="searchForm">
        <div :class="advanced ? null: 'fold'">
          <a-form-item
            label="省市区"
            :labelCol="{span: 6}"
            :wrapperCol="{span: 17, offset: 1}"
            style="width:350px;"
          >
            <a-cascader
              v-model="selectId"
              :options="options"
              :load-data="loadData"
              placeholder="请选择省市区"
              change-on-select
              @change="onChange"
            />
          </a-form-item>
          <span style="margin-left:35px; margin-top: 3px;">
            <a-button type="primary" @click="getList()">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetForm()">重置</a-button>
            <a @click="toggleAdvanced" style="margin-left: 8px" v-if="istoggleAdvanced">
              {{advanced ? '收起' : '展开'}}
              <a-icon :type="advanced ? 'up' : 'down'"/>
            </a>
            <a-button
              @click="openModal()"
              type="primary"
              icon="plus"
              class="addBtn"
              style="margin-left: 35px"
              v-permission="`Content.Learning.Add`"
            >添加</a-button>
          </span>
        </div>
      </a-form>
    </div>
    <div>
      <a-table
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        class="components-table-demo-nested"
        :pagination="{
          current: pageIndex,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="address" slot-scope="text, record">
          <span>{{record.countryName + record.provinceName + record.cityName + record.districtName}}</span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a style="margin-left: 15px" @click="importView(record)" v-permission="`Content.Learning.Import`">导入</a>

          <a style="margin-left: 15px" @click="exportView(record)" v-permission="`Content.Learning.Export`">导出</a>
          <a style="margin-left: 15px" @click="normDetai(record)" v-permission="`Content.Learning.Show`">查看</a>
          <a-popconfirm
            style="margin-left: 15px"
            title="确定删除？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="deleteEgame(record)"
            v-permission="`Content.Learning.Delete`"
          >
            <a style="color: #f00;">
              <a-icon type="delete"/>删除
            </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>
    <!-- 编辑添加能力 -->
    <a-modal v-model="isNorm" title="添加学业学习力权重" @ok="submit" @cancel="closeModle" :confirmLoading="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="Rules"
        :label-col="{span:6}"
        :wrapper-col="{span:14}"
      >
        <a-form-model-item ref="provinceId" label="省份信息">
          <a-select v-model="ruleForm.provinceId" placeholder="请选择省份" @change="provinceChange" :disabled="isimport">
            <a-select-option
              :value="item.id"
              :text="item.name"
              v-for="item in provinceList"
              :key="item.id"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="cityId" label="城市信息">
          <a-select v-model="ruleForm.cityId" placeholder="请选择城市" @change="cityChange" :disabled="isimport">
            <a-select-option
              :value="item.id"
              :text="item.name"
              v-for="item in cityList"
              :key="item.id"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="districtId" label="地区信息">
          <a-select v-model="ruleForm.districtId" placeholder="请选择地区" :disabled="isimport">
            <a-select-option
              :value="item.id"
              :text="item.name"
              v-for="item in districtList"
              :key="item.id"
            >{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div class="um-download">
        <h4 class="um-h4">模板下载</h4>
        <p align="center">
          <a
            :href="DownloadTemplate | filterUrl"
            class="templateDownload"
          >模板下载</a>
        </p>
      </div>
      <a-upload-dragger
        name="file"
        :file-list="fileList"
        :remove="handleRemove"
        :before-upload="beforeUpload"
        @change="unploadChange"
      >
        <h4 class="um-upload">上传文件</h4>
        <p class="ant-upload-drag-icon">
          <a-icon type="cloud-upload"/>
        </p>
        <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
        <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
      </a-upload-dragger>
      <a
        @click="down()"
        v-if="errorFile"
        style="text-align: center; margin: 20px 0; display: block;color:#f00;"
      >点击这里下载错误数据</a>
    </a-modal>
    <!-- 查看 -->
    <a-modal v-model="isView" title="查看学业学习力权重" width="50%" @ok="isView = false">
      <div class="viewTop">
        <span>地区: {{address}}</span>
        <!-- <downloadExcel
          style="display: inline-block;"
          :data="viewdataSource"
          :fields="excel.json_data"
          :name="address + '学业学习力权重表.xls'"
        > -->
          <a-button type="primary" style="margin-left:30px;" @click="exportView('')">导出</a-button>
        <!-- </downloadExcel> -->
      </div>
      <a-table
        :loading="viewloading"
        :columns="viewcolumns"
        :data-source="viewdataSource"
        class="components-table-demo-nested"
        :pagination="{
          current: viewpage,
          pageSize: viewlimit,
          total: viewtotal,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onviewPageChange,
          onShowSizeChange: onviewSizeChange,
        }"
      ></a-table>
    </a-modal>

    <!-- <downloadExcel
      v-show="false"
      ref="exportList"
      style="display: inline-block;"
      :data="exportData"
      :fields="excel.json_data"
      :name=" address + '学业学习力权重表.xls'"
    >
      <a>aaaaa</a>
    </downloadExcel> -->
  </a-card>
</template>

<script>
import XLSX from "xlsx";
import JsonExcel from "vue-json-excel";
const columns = [
  {
    title: "地区信息",
    scopedSlots: { customRender: "address" },
    key: "address",
    align: "center"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
const viewcolumns = [
  { title: "年级", dataIndex: "grade", key: "grade" },
  { title: "学科", dataIndex: "subject", key: "subject" },
  { title: "性别", dataIndex: "genderName", key: "genderName" },
  {
    title: "截距（常数项）",
    dataIndex: "subjectIntercept",
    key: "subjectIntercept"
  },
  { title: "权重", key: "weight", dataIndex: "weight" },
  { title: "内容名称", key: "contentName", dataIndex: "contentName" },
  { title: "能力名称", key: "abilityTypeName", dataIndex: "abilityTypeName" },
  { title: "一级能力", key: "firstAbilityName", dataIndex: "firstAbilityName" },
  {
    title: "二级能力",
    key: "secondAbilityName",
    dataIndex: "secondAbilityName"
  }
];
export default {
  name: "Learning",
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/学业学习力权重表导入模板.xlsx',
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      loading: true,
      columns,
      options: [],
      selectId: [],

      isView: false,
      viewdataSource: [],
      viewloading: true,
      viewcolumns,
      viewpage: 1,
      viewlimit: 10,
      viewtotal: 0,
      address: "",
      viewId:'',

      pageIndex: 1,
      pageSize: 10,
      total: 0,
      search: {
        countryId: 1,
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined
      },
      isNorm: false,
      ruleForm: {
        countryId: 1,
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined
      },
      Rules: {
        countryId: [
          { required: true, message: "请选择国家", trigger: "change" }
        ]
      },

      baseURL: process.env.VUE_APP_API_BASE_URL,
      errorFile: false,
      errorUrl: "",
      fileList: [],
      file: "",

      countryList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      excel: {
        json_data: {
          年级: "grade",
          学科: "subject",
          性别: "genderName",
          截距: "subjectIntercept",
          权重: "weight",
          内容能力ID: "contentAbilityId",
          内容名称: "contentName",
          能力类型名称: "abilityTypeName",
          一级能力名称: "firstAbilityName",
          二级能力名称: "secondAbilityName"
        },
        json_fields: []
      },
      exportData: [],
      isimport:false,
      record:"",
      confirmLoading:false
    };
  },
  created() {
    this.getList();
    this.getCountr(0);
  },
  watch: {
    isView() {
      if (!this.isView) {
        this.resetForm();
        this.viewdataSource = [];
        this.errorFile = false;
      }
    },
    isNorm() {
      if (!this.isNorm) {
        this.resetForm();
        this.errorFile = false;
        this.isimport = false
      }
    }
  },
  methods: {
    closeModle() {
        this.ruleForm = {
        countryId: 1,
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined
      }
      this.getCountr(0);
    },
    onChange(value) {
      this.search.provinceId = value[0];
      this.search.cityId = value[1];
      this.search.districtId = value[2];
      this.selectId = value;
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      targetOption.children = [];
      let params = {
        parentId: this.selectId[this.selectId.length - 1]
      };
      this.$http.Mechanism.address(params).then(res => {
        targetOption.loading = false;
        res.data.forEach(item => {
            let str = {};
            if (this.selectId.length < 2) {
              str = {
                value: item.id,
                label: item.name,
                isLeaf: false
              };
            } else {
              str = {
                value: item.id,
                label: item.name
              };
            }
            targetOption.children.push(JSON.parse(JSON.stringify(str)));
            this.options = [...this.options];
          });
      });
    },
    getList() {
      this.search.pageIndex = this.pageIndex;
      this.search.pageSize = this.pageSize;
      this.$http.learnList(this.search).then(res => {
        const {data} = res.data;
        this.dataSource = data.items;
        this.total = data.totalCount;
        this.loading = false;
      });
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const bool = this.fileList.filter(v => v.name === file.name).length;
      if (bool) {
        this.$message.warning("已有相同的文件，请重新选择文件");
        return false;
      }
      this.fileList = [file];
      return false;
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.file = value.file;
      } else {
        this.file = "";
      }
    },

    getCountr(id) {
      let params = {
        parentId: id
      };
      this.$http.Mechanism.address(params).then(res => {
        if (res.status && res.data.length) {
          this.options = res.data;
          this.options.forEach(item => {
            item.value = item.id;
            item.label = item.name;
            item.isLeaf = false;
          });
          res.data.map(el=>{
              el.id = '' + el.id
          })
          let level = res.data[0].level
          if(level == 1){
            this.countryList = res.data
          }else if(level == 2){
            this.provinceList = res.data
          }else if(level == 3){
            this.cityList = res.data
          }else if(level == 4){
            this.districtList = res.data
          }
        }
      });
    },
    countrChange(value, option) {
      this.getCountr(value);
    },
    provinceChange(value, option) {
      this.ruleForm.cityId = undefined;
      this.ruleForm.districtId = undefined;
      this.getCountr(value);
    },
    cityChange(value, option) {
      this.ruleForm.districtId = undefined;
      this.getCountr(value);
    },
    openModal() {
      this.isNorm = true;
      this.ruleForm = {
        countryId:1,
        provinceId:undefined,
        cityId:undefined,
        districtId:undefined,
      }
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.file) {
              this.confirmLoading = true
            const formData = new FormData();
            formData.append("file", this.file);
            formData.append("CountryId", this.ruleForm.countryId || 0);
            formData.append("ProvinceId", this.ruleForm.provinceId || 0);
            formData.append("CityId", this.ruleForm.cityId || 0);
            formData.append("DistrictId", this.ruleForm.districtId || 0);
            this.upload(formData);
          } else {
            this.$message.destroy();
            this.$message.warning("请选择xlsx文件");
          }
        } else {
        }
      });
    },
    upload(formData) {
      this.$http
        .learnUpload(formData)
        .then(res => {
          console.log(res);
          this.confirmLoading = false
          const {data, message} = res.data;
          this.isNorm = false;
          this.$message.success(message);
          this.getList();
          this.fileList = [];
          this.file = "";
          this.resetForm();
        })
        .catch(err => {
            this.confirmLoading = false
          this.isNorm = false;
        });
    },
    // 下载错误原因
    down() {
      if (this.errorUrl.substring(0, 4) == "http") {
        window.open(this.errorUrl);
      }
    },
    // 删除
    deleteEgame(record) {
      let formData = new FormData();
      formData.append("id", record.id);
      this.$http.learnDelete(formData).then(res => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
    // 查看详情
    normDetai(record) {
      this.record = record
      this.isView = true;
      this.address = record.countryName + record.provinceName + record.cityName + record.districtName;
      this.viewId = record.id;
        this.viewpage = 1;
      this.getViewData()
    },
    getViewData(){
      let params = {
        pageIndex: this.viewpage,
        pageSize: this.viewlimit,
        LearningAbilityWeightConfigIndexId: this.viewId
      };
      this.$http.learnDetailList(params).then(res => {
        const {data} = res.data;
        this.viewdataSource = data.items;
        this.viewtotal = data.totalCount;
        this.viewloading = false;
      });
    },
    // 导出
    exportView(recordStr) {
        let record = recordStr || this.record
        this.loading = true;
        this.address =
            record.countryName +
            record.provinceName +
            record.cityName +
            record.districtName;
        let params = {
            pageIndex: 1,
            pageSize: 9999999,
            LearningAbilityWeightConfigIndexId: record.id
        };
        this.$http.learnDetailList(params)
        .then(res => {
            if(!res.data){
                this.loading = false;
            }
            const {data} = res.data;
            const arr = [Object.keys(this.excel.json_data)];

            data.items.forEach(item => {
                let itemArr = [];
                for(let key in this.excel.json_data){
                    itemArr.push(item[this.excel.json_data[key]])
                }
                arr.push(itemArr)
            })
            const aoa = XLSX.utils.aoa_to_sheet(arr);
            const book = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(book, aoa, "第一页");
            XLSX.writeFile(book, this.address + "学业学习力权重表.xlsx")
            this.loading = false;
        });
    },
    // 导入
    importView(record) {
      this.isimport = true
      this.isNorm = true;
      this.ruleForm.provinceId = record.provinceId ? record.provinceId.toString() : undefined;
      this.ruleForm.cityId = record.cityId ? record.cityId.toString() : undefined;
      this.ruleForm.districtId = record.districtId ? record.districtId.toString() : undefined;
      this.ruleForm.normType = record.normType;
      this.ruleForm.deviceType = record.deviceType;
      this.getCountr(record.countryId);
      this.getCountr(record.provinceId);
      this.getCountr(record.cityId);
    },
    resetForm() {
      this.search = {
        countryId: 1,
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined
      };
      this.selectId = [];
      this.getList();
    },
    onPageChange(pageIndex, size) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    onSizeChange(pageIndex, size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.getList();
    },
    onviewPageChange(pageIndex, size) {
      this.viewpage = pageIndex;
      this.getViewData();
    },
    onviewSizeChange(pageIndex, size) {
      this.viewpage = 1;
      this.viewlimit = size;
      this.getViewData();
    }
  }
};
</script>

<style scoped>
.Learning >>> .standard-table .alert {
  display: none !important;
}

.Learning >>> .searchForm {
  display: flex;
}
.Learning >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>
<style scoped lang="less">
.um-download {
  border-top: 2px solid #eee;
  height: 60px;
  position: relative;
  margin-top: 30px;

  .um-h4 {
    padding: 0 10px;
    position: absolute;
    left: 20px;
    top: -15px;
    background-color: #fff;
    font-size: 16px;
  }

  p {
    line-height: 60px;
  }
}

.um-upload {
  font-size: 16px;
  position: absolute;
  left: 30px;
  top: 5px;
}

.um-form {
  padding: 0 24px;
}
.disAbled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
</style>
